module.exports = __webpack_public_path__ + "img/four1Green.c49f009a.jpg";